import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { LiveKitRoom as LiveKitRoomComponent } from '../SubscriptionDetails/Components/LiveKitRoom';

const LIVEKIT_SERVER_URL = 'wss://hosaksham-7o3jzavj.livekit.cloud';

export default function MeetingPage() {
    const [searchParams] = useSearchParams();
    
    const token = searchParams.get('token');
    const roomName = searchParams.get('room');
    const meetingTitle = searchParams.get('title') || 'Meeting';
    const participantName = searchParams.get('participant') || 'User';
    const userRole = searchParams.get('role') as 'teacher' | 'student' || 'student';
    const tenantId = searchParams.get('tenant') || '';
    const subscriptionId = searchParams.get('subscription') || '';
    const subscriptionName = searchParams.get('subscriptionName') || '';

    const [isValid, setIsValid] = useState(false);

    useEffect(() => {
        // Validate required parameters
        if (!token || !roomName || !tenantId) {
            console.error('Missing required meeting parameters');
            return;
        }
        setIsValid(true);
    }, [token, roomName, tenantId]);

    const handleDisconnect = () => {
        // Close the window when meeting ends
        window.close();
    };

    const handleError = (error: Error) => {
        console.error('Meeting error:', error);
        // Close window on error
        window.close();
    };

    if (!isValid) {
        return (
            <div className="h-screen w-screen bg-gray-900 flex items-center justify-center">
                <div className="text-white text-center">
                    <h1 className="text-2xl font-bold mb-4">Invalid Meeting Link</h1>
                    <p className="text-gray-400">Missing required parameters</p>
                    <button 
                        onClick={() => window.close()}
                        className="mt-4 px-4 py-2 bg-red-600 hover:bg-red-700 rounded-lg transition-colors"
                    >
                        Close Window
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="h-screen w-screen bg-gray-900">
            <LiveKitRoomComponent
                roomName={roomName}
                meetingTitle={meetingTitle}
                token={token}
                serverUrl={LIVEKIT_SERVER_URL}
                participantName={participantName}
                userRole={userRole}
                tenantId={tenantId}
                subscriptionId={subscriptionId}
                subscriptionName={subscriptionName}
                onDisconnect={handleDisconnect}
                onError={handleError}
            />
        </div>
    );
}
